import { render, staticRenderFns } from "./Facture.vue?vue&type=template&id=337e8c70"
import script from "./Facture.vue?vue&type=script&lang=js"
export * from "./Facture.vue?vue&type=script&lang=js"
import style0 from "./Facture.vue?vue&type=style&index=0&id=337e8c70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports